import { Card } from "antd";
import React from "react";
import { Wrapper } from "./CustomCard.styled";

const CustomCard = ({ children, style }) => {
  return (
    <Wrapper>
      <Card style={style}>{children}</Card>
    </Wrapper>
  );
};

export default CustomCard;
